<!--==============================
=            TASLCARD            =
===============================-->

<template>

	<v-card class="rounded-lg mb-2 "
			color="white"
			>
		<v-list-item three-line>
			
			<v-list-item-content>

				<v-list-item-title class="text-caption font-italic font-weight-black">
					{{task.title}}
				</v-list-item-title>
				<v-list-item-subtitle>{{task.date}}
				</v-list-item-subtitle>
				<badge v-if="task.type"
					   :color="badgeColor">{{task.type}}</badge>
			</v-list-item-content>
<v-list-item-avatar tile
								class="rounded-lg"
								size="40"
								color="grey"> <img
					 src="../../../assets/images/2.png"
					 alt="John"></v-list-item-avatar>

		</v-list-item>

	</v-card>
</template>
<script>
	import Badge from "./Badge.vue";
	export default {
		components: {
			Badge
		},
		props: {
			task: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			badgeColor() {
				const mappings = {
					Design: "purple",
					"Feature Request": "teal",
					Backend: "blue",
					QA: "green",
					default: "teal"
				};
				return mappings[this.task.type] || mappings.default;
			}
		}
	};
</script>

<!--====  End of TASLCARD  ====-->
